import * as React from "react";
import { read, utils } from "xlsx";

import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Box, Grid, IconButton, Typography } from "@mui/material";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import notifyContext from "../../../Context/notifyContext";

import { MdCancel } from "react-icons/md";
import { saveMany } from "../../../../services/Document__Servive";

const ImportDocuments = (props) => {
  const { client, open, onClose } = props;
  const notify = React.useContext(notifyContext);

  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");
  const [files, setFiles] = React.useState([]);

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      border: "1px solid black",
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      // backgroundColor: "primary",
      backgroundColor: theme.palette.action.hover,
    },
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  const handleSubmit = () => {
    setLoading(true);
    setError("");

    saveMany(client.id, files)
      .then(() => {
        notify("importé avec succès", "success");
        onClose();
      })
      .catch((error) => {
        if (error.response.data.message !== undefined) {
          setError(error.response.data.message);
          notify(error.response.data.message, "error");
        } else {
          setError("Problème au niveau du serveur");
          notify("Problème au niveau du serveur", "error");
        }
      })
      .finally(() => setLoading(false));
  };

  const handleImport = React.useCallback(
    (e) => {
      setFiles((prev) => [...prev, ...e.target.files]);
    },
    [setFiles]
  );

  const handleDelete = React.useCallback(
    (file, position) => {
      setFiles((prev) => {
        prev.splice(position, 1);
        return [...prev];
      });
    },
    [setFiles]
  );

  return (
    <div>
      <Dialog fullScreen open={open} onClose={() => {}}>
        <form
          style={{
            minWidth: "500px",
          }}
        >
          <DialogTitle textAlign={"center"}>
            {"Importer les documents"}{" "}
          </DialogTitle>
          <DialogContent>
            {error && (
              <Alert severity="error" sx={{ mb: 3 }}>
                {error}
              </Alert>
            )}

            {files && files.length > 0 ? (
              <Box>
                <Grid
                  justifyContent={"space-between"}
                  alignItems="center"
                  gap={4}
                  display="flex"
                  mb={2}
                >
                  <Button variant="contained" component="label">
                    Telecharger
                    <input
                      hidden
                      multiple
                      accept="application/pdf"
                      type="file"
                      onChange={handleImport}
                    />
                  </Button>
                </Grid>
                <Box textAlign={"center"} width="100%">
                  {files.length} fichier(s)
                </Box>
                <TableContainer component={Paper}>
                  <Table
                    sx={{ minWidth: 650 }}
                    size="small"
                    aria-label="import salaries table"
                  >
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell>#</StyledTableCell>
                        <StyledTableCell>Nom</StyledTableCell>
                        <StyledTableCell>Taille</StyledTableCell>
                        <StyledTableCell>Derniere Modification</StyledTableCell>
                        <StyledTableCell></StyledTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      {files?.map((row, index) => {
                        return (
                          <StyledTableRow
                            key={row.name + index}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                          >
                            <TableCell component="th" scope="row">
                              {index + 1}
                            </TableCell>
                            <TableCell>{row.name}</TableCell>
                            <TableCell>{row.size}</TableCell>
                            <TableCell>
                              {new Date(row.lastModified).toLocaleDateString()}
                            </TableCell>
                            <TableCell>
                              <IconButton
                                color="error"
                                onClick={() => handleDelete(row, index)}
                              >
                                <MdCancel />
                              </IconButton>
                            </TableCell>
                          </StyledTableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            ) : (
              <Box
                height={"100%"}
                width={"100%"}
                border={1}
                borderColor={"darkgrey"}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  padding: "16px",
                  gap: "40px",
                  borderStyle: "dashed",
                }}
              >
                <Typography fontSize={20} fontWeight={700}>
                  Aucun fichier selectionne
                </Typography>
                <Button variant="contained" component="label">
                  Télécharger
                  <input
                    hidden
                    multiple
                    accept="application/pdf"
                    type="file"
                    onChange={handleImport}
                  />
                </Button>
              </Box>
            )}
          </DialogContent>
          <DialogActions
            sx={{
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Button onClick={onClose} variant="outlined">
              Annuler
            </Button>
            <Button
              variant="contained"
              type={loading ? "button" : "submit"}
              disabled={loading}
              endIcon={loading ? <CircularProgress /> : <></>}
              onClick={() => {
                handleSubmit();
              }}
            >
              {"Importer"}{" "}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
};

export default React.memo(ImportDocuments);
